var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-2 sbtn",attrs:{"color":"primary","dark":"","to":"/staff/add"}},[_vm._v(_vm._s(_vm.$t("staffPage.new")))]),_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.STAFF,"titles":_vm.titles,"fields-hidden-main":[
      'deleted_at',
      'updated_at',
      'last_name',
      'profile_image',
      'phone_number',
      'identity',
      'telegram_username',
      'blacklisted_at',
      'blacklist_note',
      'activation_code',
    ],"fields-hidden-add":[
      'id',
      'deleted_at',
      'created_at',
      'updated_at',
      'roles',
      'blacklisted_at',
      'blacklist_note',
    ],"fields-hidden-edit":[
      'id',
      'deleted_at',
      'created_at',
      'updated_at',
      'roles',
      'blacklisted_at',
      'blacklist_note',
      'activation_code',
    ],"input-types-add":{
      password: 'password',
    },"input-types-edit":{
      password: 'password',
    },"fields-extra-add":_vm.fieldsExtraAdd,"fields-extra-edit":_vm.fieldsExtraEdit,"fields-extra-main":_vm.fieldsExtraMain,"formatter":_vm.formatters,"title":_vm.$t('staffPage.pageTitle'),"enableEdit":true,"enableAdd":false,"actions-extra-main":_vm.actionsExtraMain,"load-before-edit":"","edit-extra-data":_vm.editExtraData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }